import { Sheet } from '../components/Sheet';
import { TransferBanner, UntilBox } from '../components/ScreenBlocks';
import { Icon } from '../components/icons';
import { useT } from '../i18n/I18nProvider';
import { TRANSFERS } from '../domain/transfers';
import type { ScreenModel } from '../domain/resolveScreen';
import type { TransferDirection } from '../domain/types';

interface Props {
  /** Model obrazovky pod dialogem – dialog z něj zopakuje banner a okno expedice. */
  model: ScreenModel;
  direction: TransferDirection;
  shipmentNumber: string;
  stateName: string;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Potvrzení převozu mezi sklady (spec 3, prototyp `02-dialogy`).
 *
 * Popup otevírají OBĚ tlačítka v liště – „Potvrdit převoz" i „Skenovat další".
 * Tap na navyklé tlačítko tak skladníkovi rovnou řekne, co se po něm chce,
 * místo aby zjistil, že další sken nejde.
 *
 * Dialog zopakuje banner a okno expedice, aby skladník viděl **kam a odkdy**
 * balík jede, aniž by dialog zavíral. A ukazuje PŘESNOU hodnotu, která se
 * zapíše do objednávky – ne obecné „opravdu chcete pokračovat?".
 */
export function ConfirmTransferSheet({
  model,
  direction,
  shipmentNumber,
  stateName,
  onClose,
  onConfirm,
}: Props) {
  const { t } = useT();
  const value = t(TRANSFERS[direction].valueKey);

  return (
    <Sheet title={t('confirmTitle')} meta={`${shipmentNumber} · ${stateName}`} onClose={onClose}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14 }}>
        <TransferBanner model={model} />
        <UntilBox model={model} />
      </div>

      <div className="note-text">{t('confirmNote', { W: value })}</div>

      <div className="row">
        <button className="btn primary" type="button" onClick={onConfirm}>
          <Icon name="check" />
          {t('confirmTr')}
        </button>
        <button className="btn ghost" type="button" onClick={onClose}>
          {t('cancel')}
        </button>
      </div>
    </Sheet>
  );
}
